import http from "../../../libs/http";
import { api } from '../../../pages/utils'

http.setMockRule(false, mock => {
  mock.onPost(api.operationConf.list).reply(200, {
    code: 0,
    data: {
      platformList: [{id: 0,name : 'h5'}, {id: 1, name: 'pc'}, {id: 2, name: 'app'}],
      statusList: [{id: 0, name: '已上线'},{id: 1, name: '已下线'}],
      page: {},
      operationList: [{
        id: 1,
        platformName: 'H5',
        pageName: '首页',
        name: 'banner',
        status: '已上线',
        updateTime: '2019-04-03 14:27:36',
        remark: '备注信息',
        updateUserName: '赵晔',
      },{
        id: 2,
        platformName: 'H5',
        pageName: '首页',
        name: 'banner',
        status: '已上线',
        updateTime: '2019-04-03 14:27:36',
        remark: '备注信息',
        updateUserName: '赵晔',
      },{
        id: 3,
        platformName: 'H5',
        pageName: '首页',
        name: 'banner',
        status: '已上线',
        updateTime: '2019-04-03 14:27:36',
        remark: '备注信息',
        updateUserName: '赵晔',
      },{
        id: 4,
        platformName: 'H5',
        pageName: '首页',
        name: 'banner',
        status: '已上线',
        updateTime: '2019-04-03 14:27:36',
        remark: '备注信息',
        updateUserName: '赵晔',
      },{
        id: 5,
        platformName: 'H5',
        pageName: '首页',
        name: 'banner',
        status: '已上线',
        updateTime: '2019-04-03 14:27:36',
        remark: '备注信息',
        updateUserName: '赵晔',
      }]
    }
  })
  
  mock.onPost(api.operationConf.getPageListByPlatfromId).reply(200, {
    code: 0,
    data: {
      pageList: [{id: 0, name: '首页'}, {id: 1, name: '科技频道'}]
    }
  })

  mock.onPost(api.operationConf.getOperationListByPageId).reply(200, {
    code: 0,
    data: {
      operationList: [{id: 0, name: '右下角小球'}, {id: 1, name: 'bannner'},{id: 2, name: '信息流NO.11'}]
    }
  })
  
  mock.onPost(api.operationConf.detail).reply(200, {
    code: 0,
    data: {
      status           : '已上线',
      createTime       : '2019-12-20 22:33:44',
      updateTime       : '2019-12-20 22:33:44',
      updateUserName   : '赵晔',
      remark           : '备注备注',
      platformName     : 'APP',
      pageName         : '首页',
      name             : 'banner',
      frameNum         : '12',
      skipIdList       : [1,2,4],
      skipList         : [{id: 1, name: '文章'},{id: 2, name: '横竖视频'},{id: 3, name: '话题'},{id: 4, name: '开氪文章'}],
      titleType        : '非必填',
      coverPanel       : '有，195*195',
      groupList        : ['组', '组'],
    }
  })

})